import axiosInstance from '../Core/RestHelper';
import { CreateCredentialsRequest, GetRoleApiResponse } from '../Model/Aws';
import { Status } from '../Model/Deployment';

export class AwsService {
    static async getRole(): Promise<GetRoleApiResponse> {
        try {
            const response = await axiosInstance.get('/aws/client/');
            return {
              ...response.data,
              success: true,
            };
          } catch (error) {
            return {
              success: false,
              message: 'Failed to get user role',
            };
        }
      }

    static async verifyConnection(role: string): Promise<Status> {
        try {
            let roleObj = {role_arn:role}
            const response = await axiosInstance.post('/aws/verify', roleObj);
            return response.data;
        } catch (error) {
            throw new Error('Failed to verify connection');
        }
    }

    static async createCredentials(credentials: CreateCredentialsRequest): Promise<Status> {
        try {
            const response = await axiosInstance.post('/aws/client/', credentials);
            return response.data;
        } catch (error) {
            throw new Error('Failed to create credentials');
        }
    }
}